module.exports = __webpack_public_path__ + "img/hr-inserter-hand-base.55ff3d0b.png";